var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgKontak = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9528 10.0013C10.5301 10.0013 12.6195 7.91196 12.6195 5.33464C12.6195 2.75731 10.5301 0.667969 7.9528 0.667969C5.37547 0.667969 3.28613 2.75731 3.28613 5.33464C3.28613 7.91196 5.37547 10.0013 7.9528 10.0013Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1372 9.4823C12.9845 9.32964 12.8218 9.18697 12.6552 9.04764C12.0951 9.76032 11.3804 10.3364 10.5651 10.7324C9.74978 11.1284 8.85511 11.334 7.9487 11.3335C7.04229 11.3331 6.14784 11.1266 5.3329 10.7298C4.51796 10.333 3.80385 9.75621 3.24451 9.04297C2.42006 9.72949 1.7573 10.5895 1.30349 11.5616C0.849681 12.5338 0.616018 13.5941 0.619172 14.667C0.619172 14.8438 0.68941 15.0133 0.814434 15.1384C0.939459 15.2634 1.10903 15.3336 1.28584 15.3336H14.6192C14.796 15.3336 14.9656 15.2634 15.0906 15.1384C15.2156 15.0133 15.2858 14.8438 15.2858 14.667C15.2882 13.7036 15.0996 12.7494 14.7307 11.8595C14.3619 10.9695 13.8203 10.1615 13.1372 9.4823V9.4823Z",
    fill: "#8E8E8E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKontak, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kontak.9b2be956.svg";
export { ForwardRef as ReactComponent };